/**
 * Entries + engagement admin endpoints (docs/modules/entries.md, docs/modules/engagement.md). Thin wrappers over
 * the console client; shapes come from @windrop/contracts.
 */
import type {
  DisqualifyEntryRequest,
  EngagementTaskAdminDto,
  EntryAdminListQuery,
  EntryAdminPage,
  EntryCountsDto,
  EntryDto,
  ParticipantProfileDto,
  ReviewTaskCompletionRequest,
  TaskCompletionAdminPage,
  TaskCompletionDto,
  TaskCompletionListQuery,
} from '@windrop/contracts';
import { api } from './client';

export const entriesApi = {
  list: (lotteryId: string, query: Partial<EntryAdminListQuery> = {}) =>
    api.get<EntryAdminPage>(`/v1/admin/lotteries/${lotteryId}/entries`, query),
  summary: (lotteryId: string) => api.get<EntryCountsDto>(`/v1/admin/lotteries/${lotteryId}/entries/summary`),
  disqualify: (entryId: string, body: DisqualifyEntryRequest) =>
    api.post<EntryDto>(`/v1/admin/entries/${entryId}/disqualify`, body),
  participant: (participantId: string) =>
    api.get<ParticipantProfileDto>(`/v1/admin/participants/${participantId}`),
};

export const engagementApi = {
  tasks: (lotteryId: string) =>
    api.get<EngagementTaskAdminDto[]>('/v1/admin/engagement-tasks', { lotteryId }),
  completions: (query: Partial<TaskCompletionListQuery> = {}) =>
    api.get<TaskCompletionAdminPage>('/v1/admin/engagement/completions', query),
  review: (completionId: string, body: ReviewTaskCompletionRequest) =>
    api.post<TaskCompletionDto>(`/v1/admin/engagement-tasks/completions/${completionId}/review`, body),
};
